import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'core-user-details-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './user-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailsSkeletonCoreComponent {}
